// Traducir los errores de entrada a algo que una persona pueda usar.
//
// ⚠️ NACIÓ DE UN CASO REAL (3-ago-2026, madrugada). La base del proyecto se
// quedó sin conexiones libres —«remaining connection slots are reserved for
// roles with the SUPERUSER attribute»— así que GoTrue no pudo consultar y
// devolvió un 500 sin mensaje aprovechable. El panel pintó literalmente `{}` en
// la caja de error, debajo del formulario. Cristhian, viendo eso, concluyó lo
// más razonable: «se cayó Chat AI» y «mi contraseña ya no sirve». Ninguna de las
// dos era cierta — el bot estaba respondiendo y su clave estaba bien.
//
// La lección no es «faltaba un mensaje»: es que un error de INFRAESTRUCTURA se
// le presentó al usuario como un error SUYO. Distinguir «es tu clave» de «somos
// nosotros» cambia lo que la persona hace después: reintentar en un minuto, o
// ponerse a cambiar contraseñas creyendo que perdió la cuenta.
export function mensajeDeErrorAuth(e: unknown): string {
  const err = e as { message?: unknown; status?: number; code?: string } | null;
  const m = typeof err?.message === "string" ? err.message : "";
  const status = typeof err?.status === "number" ? err.status : 0;

  // Culpa nuestra: el servidor no está respondiendo. Se dice con todas las
  // letras que NO es su contraseña, porque es lo primero que va a pensar.
  if (status >= 500 || /database error|unexpected_failure|connection|timeout/i.test(m)) {
    return "El servidor no está respondiendo en este momento. No es tu contraseña: "
      + "espera un minuto y vuelve a intentar.";
  }
  if (status === 429 || /rate limit|too many|demasiad/i.test(m)) {
    return "Demasiados intentos seguidos. Espera un par de minutos y vuelve a intentar.";
  }
  if (/invalid.*credential|invalid login/i.test(m)) return "Correo o contraseña incorrectos.";
  if (/email not confirmed/i.test(m)) return "Esta cuenta todavía no está confirmada.";
  if (/user not found/i.test(m)) return "Correo o contraseña incorrectos.";

  // Último recurso: si lo que queda no es una frase legible —`{}`, `[object
  // Object]`, una cadena vacía— NO se enseña. Un mensaje que el usuario no puede
  // usar es peor que uno genérico, porque parece información y no lo es.
  const legible = m && m !== "{}" && !m.startsWith("[object") && m.length > 3;
  return legible ? m : "No se pudo entrar. Intenta de nuevo en un momento.";
}
